module.exports = __webpack_public_path__ + "img/Med02.06-2-20190232-014_3.2653b62e.jpg";